{
    "coordinates": [
        62.55,
        -127.75
    ],
    "tooltip": "Moth",
    "title": "Man on the Hill Locality (MOTH)",
    "country": "Canada",
    "period": "Devonian",
    "alt": "TODO"
}
